import React, { useState } from "react";
import Modal from "./Modal";
import { FaFileAlt, FaPiggyBank, FaThermometerHalf, FaHome } from "react-icons/fa";

import "./Services.css";
import ISFPImage from "./assets/ISFP.png";
import HeizlastImage from "./assets/Heizung.png";
import BeratungImage from "./assets/Beratung.png";
import EnergieausweisImage from "./assets/Energieausweise.png";

export default function Services() {
  const [openModalIndex, setOpenModalIndex] = useState(null);

  const services = [
    {
      icon: <FaThermometerHalf />,
      title: "Heizlastberechnung",
      desc: "Die präzise Berechnung der Heizlast ist entscheidend für eine effiziente und passgenaue Heizungsanlage. So wissen Sie genau, welche Wärmemenge Ihr Gebäude benötigt, um auch bei kalten Außentemperaturen komfortable Temperaturen in allen Räumen sicherzustellen.",
      hasDropdown: true,
      dropdownLabel: "Mehr Informationen",
      dropdownContent: (
        <>
          <p><strong>1. Vor-Ort-Bestandsaufnahme</strong></p>
<p>
  Damit Ihre Heizungsanlage optimal ausgelegt werden kann, erfassen wir Ihr Gebäude umfassend. Berücksichtigt werden unter anderem das Baujahr, der Aufbau von Wänden und Dämmungen, Fensterflächen, Raumgrößen sowie die Nutzung der einzelnen Räume.
</p>

<p><strong>2. Heizlastberechnung</strong></p>
<p>
  Auf Grundlage der erfassten Gebäudedaten berechnen wir die individuelle Heizlast für jeden Raum. Diese gibt an, welche Wärmemenge erforderlich ist, um auch bei niedrigen Außentemperaturen ein angenehmes Raumklima sicherzustellen.
</p>

<p><strong>3. Ergebnisanalyse</strong></p>
<p>
  Sie erhalten eine übersichtliche und verständliche Auswertung, aus der hervorgeht, wie viel Wärme in den einzelnen Räumen benötigt wird. Auf dieser Basis kann die Heizungsanlage effizient und bedarfsgerecht dimensioniert werden. Das führt zu geringerem Energieverbrauch, niedrigeren Heizkosten und einem gleichmäßig behaglichen Raumklima.
</p>

<p><strong>Warum eine Heizlastberechnung so wichtig ist:</strong></p>
<ul className="more-info-points">
  <li><strong>Passgenaue Dimensionierung:</strong> Verhindert Über- oder Unterdimensionierung sowie unnötige Kosten und Energieverluste.</li>
  <li><strong>Höhere Effizienz:</strong> Besonders entscheidend für den wirtschaftlichen Betrieb von Wärmepumpen.</li>
  <li><strong>Energie- und Kosteneinsparung:</strong> Eine präzise Berechnung reduziert die Heizkosten langfristig.</li>
  <li><strong>Planungssicherheit:</strong> Unverzichtbar bei Sanierungen und Modernisierungsmaßnahmen.</li>
  <li><strong>Förderfähigkeit:</strong> Voraussetzung für zahlreiche Förderprogramme.</li>
</ul>


          <div className="image">
            <img src={HeizlastImage} alt="Heizlastberechnung Bild" />
          </div>
        </>
      ),
    },
    {
      icon: <FaFileAlt />,
      title: "Individueller Sanierungsfahrplan (iSFP)",
      desc: "Der individuelle Sanierungsfahrplan zeigt Ihnen Schritt für Schritt, wie Sie Ihr Haus effizient modernisieren und zukunftssicher gestalten können.",
      hasDropdown: true,
      dropdownLabel: "Mehr Informationen",
      dropdownContent: (
        <>
          <p><strong>1. Vor-Ort-Bestandsaufnahme</strong></p>
<p>
  Zu Beginn führen wir einen Termin direkt bei Ihnen vor Ort durch. Dabei erfassen wir alle relevanten Daten Ihres Gebäudes – von der Baukonstruktion über die Anlagentechnik bis hin zum energetischen Zustand. Auf dieser Grundlage erstellen wir eine detaillierte Darstellung des aktuellen Ist-Zustands.
</p>

<p><strong>2. Maßgeschneidertes Sanierungskonzept</strong></p>
<p>
  Aufbauend auf der Analyse entwickeln wir ein individuell auf Ihr Gebäude abgestimmtes Sanierungskonzept. Die empfohlenen Maßnahmen werden übersichtlich dargestellt und hinsichtlich Energieeinsparung, CO₂-Reduktion und Kosten bewertet. Zudem prüfen wir den Einsatz zukunftsfähiger Energielösungen wie Wärmepumpen oder Photovoltaikanlagen.
</p>

<p><strong>3. Persönliche Ergebnisbesprechung</strong></p>
<p>
  Die Ergebnisse stellen wir Ihnen in einem persönlichen Gespräch vor. Sie erhalten klare und verständliche Handlungsempfehlungen – sowohl für einzelne Maßnahmen als auch für eine umfassende Sanierung.
</p>

<p><strong>Ihre Vorteile mit dem iSFP:</strong></p>
<ul className="more-info-points">
  <li><strong>Detaillierte Analyse des Ist-Zustands</strong> Ihrer Immobilie</li>
  <li><strong>Individuelle Sanierungsstrategie</strong> statt pauschaler Lösungen</li>
  <li>Prüfung der Eignung für <strong>Wärmepumpe und Photovoltaik</strong></li>
  <li><strong>Förderung der Beratung:</strong> bis zu 50 % möglich</li>
  <li>
    <strong>Zusätzlicher Förderbonus:</strong> bis zu 20 % bei Umsetzung. Bei Umsetzung von Maßnahmen aus dem iSFP innerhalb von 15 Jahren ist ein zusätzlicher Bonus von 5 % möglich (ausgenommen Heizungstausch).
  </li>
  <li><strong>Förderfähige Investitionskosten:</strong> bis zu 60.000 € pro Wohneinheit und Jahr</li>
  <li><strong>Gültigkeit:</strong> 15 Jahre – langfristige Planungssicherheit</li>
  <li>
    <strong>Wichtig:</strong> Der Sanierungsfahrplan ist unverbindlich und dient als Orientierung für den sinnvollsten Sanierungsablauf.
  </li>
</ul>

<p><strong>
  Der iSFP bietet Ihnen eine klare, wirtschaftlich sinnvolle Grundlage für die energetische Sanierung Ihres Hauses.
</strong></p>




          <div className="image">
            <img src={ISFPImage} alt="iSFP Modernisierung" />
          </div>
        </>
      )
    },

    {
      icon: <FaPiggyBank />,
      title: "Fördermittel & Baubegleitung",
      desc: "Wir unterstützen Sie professionell bei der Nutzung staatlicher Förderprogramme und begleiten Ihre Baumaßnahmen effizient und transparent.",
      hasDropdown: true,
      dropdownLabel: "Mehr Informationen",
      dropdownContent: (
        <>
<p>
  Wir unterstützen Sie dabei, geeignete Förderprogramme für Ihr Vorhaben zu finden und diese bestmöglich auszuschöpfen.
</p>

<p><strong>1. Prüfung der Fördermöglichkeiten</strong></p>
<p>
  Als zertifizierte Energieeffizienzexperten (EEE) analysieren wir alle für Ihr Projekt relevanten Förderprogramme von BAFA und KfW und bewerten deren Einsatzmöglichkeiten.
</p>

<p><strong>2. Vorbereitung der Unterlagen & Unterstützung bei der Antragstellung</strong></p>
<p>
  Wir erstellen im Vorfeld alle erforderlichen Dokumente, darunter die Technische Projektbeschreibung (TPB) sowie die Berechnungen zum Antrag (BzA), und begleiten Sie bei der Antragstellung. 
  Nach Abschluss der Maßnahmen übernehmen wir zudem die Erstellung der notwendigen Nachweise, wie den Technischen Projektnachweis (TPN) und die Bestätigung nach Durchführung (BnD).
</p>

<p><strong>3. Baubegleitung und Optimierung</strong></p>
<p>
  Während der Umsetzung Ihrer Baumaßnahmen stehen wir Ihnen fachlich zur Seite, um eine effiziente Umsetzung sicherzustellen und die maximal möglichen Fördermittel zu erhalten.
</p>

<p><strong>Ihre Vorteile mit unserer Fördermittelbegleitung:</strong></p>
<ul className="more-info-points">
  <li><strong>Klare und transparente Übersicht</strong> über alle relevanten Förderprogramme</li>
  <li><strong>Fachkundige Unterstützung</strong> bei Dokumentation und Antragstellung</li>
  <li><strong>Optimale Ausschöpfung</strong> von Zuschüssen und Fördermitteln</li>
  <li><strong>Kompetente Begleitung</strong> während der gesamten Umsetzungsphase</li>
</ul>


          <div className="image">
            <img src={BeratungImage} alt="Fördermittel Bild" />
          </div>
        </>
      ),
    },
    {    icon: <FaHome />,
      title: "Energieausweis",
      desc: "Der Energieausweis zeigt den Energieverbrauch oder -bedarf Ihres Gebäudes und macht seine Energieeffizienz transparent. Er ist gesetzlich vorgeschrieben bei Verkauf, Vermietung oder Verpachtung und dient Eigentümern sowie Interessenten als Orientierung.",
      hasDropdown: true,
      dropdownLabel: "Mehr Informationen",
      dropdownContent: (
        <>
          <p>
  Ein Energieausweis gibt Auskunft über die Energieeffizienz Ihres Gebäudes. Er ist 10 Jahre gültig und wird bei Verkauf, Vermietung oder Verpachtung benötigt.
</p>

<p><strong>1. Auswahl der Ausweisart</strong></p>
<p>
  Es gibt zwei Varianten: den <strong>Verbrauchsausweis</strong> und den <strong>Bedarfsausweis</strong>. 
  Der Verbrauchsausweis dokumentiert den tatsächlichen Energieverbrauch der letzten drei Jahre und berücksichtigt dabei Nutzergewohnheiten, Heizverhalten sowie Leerstände. 
  Der Bedarfsausweis hingegen ermittelt den theoretischen Energiebedarf auf Basis von Bauplänen, Dämmwerten und technischer Ausstattung unter standardisierten Bedingungen.
</p>

<p><strong>2. Erfassung der Gebäudedaten</strong></p>
<p>
  Für den Verbrauchsausweis werten wir die bisherigen Energieverbrauchsdaten aus und berücksichtigen Heizungsart und Anlagentechnik. 
  Für den Bedarfsausweis erfassen wir die Gebäudehülle, Fenster, Dämmung, Heizungsanlage und Lüftungssysteme detailliert.
</p>

<p><strong>3. Auswertung und Erstellung</strong></p>
<p>
  Anschließend werden alle Daten ausgewertet und der gesetzlich konforme Energieausweis erstellt. 
  Sie erhalten einen Nachweis, der die Energieeffizienz Ihres Gebäudes transparent darstellt und bei Bedarf an Mieter, Käufer oder Behörden weitergegeben werden kann.
</p>

<p><strong>Warum ein Energieausweis wichtig ist:</strong></p>
<ul className="more-info-points">
  <li><strong>Transparenz:</strong> Macht den Energieverbrauch oder -bedarf Ihres Gebäudes klar sichtbar.</li>
  <li><strong>Vergleichbarkeit:</strong> Bedarfsausweise erlauben den Vergleich unterschiedlicher Gebäude.</li>
  <li><strong>Rechtliche Sicherheit:</strong> Pflicht bei Verkauf, Vermietung oder Verpachtung.</li>
  <li><strong>Planungshilfe:</strong> Dient als Grundlage für energetische Sanierungen und die Nutzung von Fördermöglichkeiten.</li>
</ul>


          <div className="image">
            <img src={EnergieausweisImage} alt="Energieausweis Bild" />
          </div>
        </>
      ),
    },
  


  ];

  return (
    <section id="services" className="services">
      <h2 className="services-title">Unsere Leistungen</h2>
      <p className="services-subtitle">
        Energieverbrauch senken. Nachhaltig handeln. Wir beraten Sie gerne.
      </p>

      <div className="services-grid refined">
        {services.map((s, i) => (
          <div key={i} className="service-card elegant">
            <div className="service-header">
              <div className="service-icon refined-icon">{s.icon}</div>
              <h3>{s.title}</h3>
            </div>
            <p>{s.desc}</p>

            {s.hasDropdown && (
              <button
                className="more-info-btn"
                onClick={() => setOpenModalIndex(i)}
              >
                {s.dropdownLabel}
              </button>
            )}
          </div>
        ))}
      </div>

      {openModalIndex !== null && (
        <Modal
          open={openModalIndex !== null}
          onClose={() => setOpenModalIndex(null)}
          title={services[openModalIndex].title}
        >
          {services[openModalIndex].dropdownContent}
        </Modal>
      )}
    </section>
  );
}
